import { fetchOk } from '@atlassian/mpac-fetch-wrapper';
import { getPartnerApisHeaders } from './partnerApisHeaders';
export const DefaultPartnerUserPreferences = {
  isNewReportsView: false
};

/* Update new reports switcher flag status */
export const updatePartnerUserPreferences = (mpacBaseUrl, preferences) => fetchOk("".concat(mpacBaseUrl, "/gateway/api/marketplace/catalog/internal/partner-user-preferences"), {
  method: 'PUT',
  headers: getPartnerApisHeaders({
    'Content-Type': 'application/json'
  }),
  body: JSON.stringify(preferences)
}).then(response => response.json());

/* get partner user preferences */
export const getPartnerUserPreferences = mpacBaseUrl => fetchOk("".concat(mpacBaseUrl, "/gateway/api/marketplace/catalog/internal/partner-user-preferences"), {
  headers: getPartnerApisHeaders()
}).then(response => response.json()).catch(error => {
  if (error.status === 404) {
    return DefaultPartnerUserPreferences;
  }
  throw error;
});